const DEFAULT_DONORA_URL = "https://donora.help/app";

const DONORA_URLS_BY_APP_ID = {
  "volyn.gas":
    "https://donora.help/app?utm_source=volyn_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "vinnytsia.gas":
    "https://donora.help/app?utm_source=vinnytsia_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "dnipro.gas":
    "https://donora.help/app?utm_source=dnipro_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "zhytomyr.gas":
    "https://donora.help/app?utm_source=zhytomyr_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "zakarpattya.gas":
    "https://donora.help/app?utm_source=zakarpattia_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "zaporizhzhia.gas":
    "https://donora.help/app?utm_source=zaporizhzhia_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "kyiv.gas":
    "https://donora.help/app?utm_source=kyiv_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "kirovograd.gas":
    "https://donora.help/app?utm_source=kirovohrad_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "lviv.gas":
    "https://donora.help/app?utm_source=lviv_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "mykolaiv.gas":
    "https://donora.help/app?utm_source=mykolaiv_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "odesa.gas":
    "https://donora.help/app?utm_source=odesa_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "poltava.gas":
    "https://donora.help/app?utm_source=poltava_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "prykarpattya.gas":
    "https://donora.help/app?utm_source=prykarpattia_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "rivne.gas":
    "https://donora.help/app?utm_source=rivne_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "sumy.gas":
    "https://donora.help/app?utm_source=sumy_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "ternopil.gas":
    "https://donora.help/app?utm_source=ternopil_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "kharkiv.gas":
    "https://donora.help/app?utm_source=kharkiv_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "kherson.gas":
    "https://donora.help/app?utm_source=kherson_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "khmelnytskyi.gas":
    "https://donora.help/app?utm_source=khmelnytskyi_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "cherkasy.gas":
    "https://donora.help/app?utm_source=cherkasy_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "chernivtsi.gas":
    "https://donora.help/app?utm_source=chernivtsi_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
  "chernihiv.gas":
    "https://donora.help/app?utm_source=chernihiv_gaz&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=gas",
};

export function getDonoraUrl(appId) {
  return (
    process.env.VUE_APP_DONORA_URL ||
    DONORA_URLS_BY_APP_ID[appId] ||
    DEFAULT_DONORA_URL
  );
}
